import React, { useState } from 'react';
import './EditCore.css';

const EditCore = () => {
  const [coreValues, setCoreValues] = useState([
    {
      img: 'https://i.imgur.com/53ZrRLx.gif',
      title: 'Sustainability',
      description: 'We prioritize sustainable practices, ensuring our products have minimal impact on the environment.'
    },
    {
      img: 'https://i.imgur.com/yh4NzdS.gif',
      title: 'Ethical Production',
      description: 'Our production processes are ethical, focusing on fair labor practices and reducing waste.'
    },
    {
      img: 'https://i.imgur.com/VLufTr6.gif',
      title: 'Renewable',
      description: 'We use renewable resources to create our products, supporting a circular economy.'
    },
    {
      img: 'https://i.imgur.com/Fotn3hR.gif',
      title: 'Carbon Neutral',
      description: 'We aim to be carbon neutral by offsetting our emissions and investing in green technologies.'
    }
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedCoreValues = [...coreValues];
    updatedCoreValues[index][field] = value;
    setCoreValues(updatedCoreValues);
  };

  const moveCard = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= coreValues.length) return;
    const updatedCoreValues = [...coreValues];
    const [movedCard] = updatedCoreValues.splice(index, 1);
    updatedCoreValues.splice(newIndex, 0, movedCard);
    setCoreValues(updatedCoreValues);
  };

  return (
    <div className="edit-about edit-core-values-container">
      <h2>Edit Core Values</h2>
      <div className="cards-container">
        {coreValues.map((value, index) => (
          <div key={index} className="edit-card">
            <h2>Card {index + 1}
             
            </h2>

            {/* Image Display */}
            <div className="divvv">
              
            <div className="image-preview">
              <img src={value.img} alt={`Card ${index + 1} Image`} />
            </div>
         <div className="cv-cd-ed">
             
            <div className="form-group">
              <label>Image URL</label>
              <input
                type="text"
                placeholder="Image URL"
                value={value.img}
                onChange={(e) => handleInputChange(index, 'img', e.target.value)}
              />
              <button
                onClick={() => {
                  const newImg = prompt('Enter new image URL:', value.img);
                  if (newImg) handleInputChange(index, 'img', newImg);
                }}
                className="change-image-button"
              >
                Change Image
              </button>
            </div>

            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                placeholder="Title"
                value={value.title}
                onChange={(e) => handleInputChange(index, 'title', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                placeholder="Description"
                value={value.description}
                onChange={(e) => handleInputChange(index, 'description', e.target.value)}
              />
            </div>
            <div className="button-group">
              <button onClick={() => moveCard(index, -1)} disabled={index === 0}>
                Move Left
              </button>
              <button onClick={() => moveCard(index, 1)} disabled={index === coreValues.length - 1}>
                Move Right
              </button>
            </div>
       </div>
            </div>   <div className="button-group">
                 <button type="button" className="save-btn">
        Save Changes
      </button>
      </div> </div>
        ))}
      </div>
    </div>
  );
};

export default EditCore;
